import { useEffect, useState } from "react";
import { heroHeadlines, liveFeeds } from "@/mocks/news";

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = window.setInterval(() => {
      setIdx((i) => (i + 1) % heroHeadlines.length);
    }, 3600);
    return () => window.clearInterval(t);
  }, []);

  const active = heroHeadlines[idx];

  return (
    <section id="home" className="relative overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20evening%20city%20night%20market%20in%20China%2C%20string%20lights%20glowing%20over%20food%20stalls%2C%20young%20people%20walking%20and%20chatting%2C%20lively%20street%20atmosphere%2C%20coral%20and%20amber%20tonal%20grading%2C%20editorial%20documentary%20photography%2C%20soft%20warm%20highlights%2C%20cinematic%20depth%2C%20no%20text&width=1600&height=720&seq=gua-hero-x1&orientation=landscape"
          alt="国产吃瓜 今日瓜与现场快讯 城市夜间市集"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50"></div>

      {/* content */}
      <div className="relative mx-auto flex min-h-[480px] max-w-[1200px] flex-col items-center justify-center px-4 pb-14 pt-28 text-center md:min-h-[620px] md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs text-white backdrop-blur md:text-sm">
          <span className="h-2 w-2 rounded-full bg-accent-400 animate-pulse"></span>
          国产吃瓜 · 今日瓜与现场快讯持续更新
        </span>

        <h2 className="mt-6 max-w-3xl text-3xl font-bold leading-tight text-white md:text-5xl md:leading-tight">
          不错过任何一场热闹
        </h2>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          本地新鲜事、热门现场、突发动态一站掌握。想知道今天大家在聊什么，点开就能看到国产吃瓜快讯与热点追踪的实时同步。
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#today"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            去今日瓜
          </a>
          <a
            href="#scene"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-6 py-3 text-sm font-medium text-white backdrop-blur transition-colors hover:bg-white/25"
          >
            <i className="ri-camera-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            看现场直击
          </a>
        </div>

        {/* rotating headline chip */}
        <div key={idx} className="animate-fadeUp mt-9 inline-flex max-w-full items-center gap-2 rounded-full bg-black/35 px-4 py-2 text-left backdrop-blur">
          <span className="shrink-0 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-bold text-foreground-950">
            {active.tag}
          </span>
          <span className="truncate text-sm text-white md:text-[15px]">{active.title}</span>
        </div>
      </div>

      {/* live marquee */}
      <div className="relative border-y border-background-200 bg-background-50">
        <div className="mx-auto flex max-w-[1200px] items-center px-4 py-3 md:px-6">
          <span className="z-10 mr-4 flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
            <i className="ri-radio-2-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center gap-10">
              {[...liveFeeds, ...liveFeeds].map((f, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}